import { keyValuePair } from '../../models/common.model';

export const encryptionKeys = {
  IV: '7g5y6fdlctdegihj',
  key: '5pa7nohechag5j2'
};

export const userRole = {
  Admin: 1,
  Vendor: 2
};

export const ROLE = {
  ADMIN: 1,
  USER: 2,
  VENDOR: 3,
  SUBVENDOR: 4
};

export const VERIFICATION_TYPE = {
  SIGNUP: 1,
  LOGIN: 2,
  UPDATE: 3,
  FORGET: 4
};

export const statusTabs = {
  Pending: 0,
  Accepted: 1,
  Rejected: 2
};

export const bookingStatusTabsFineDining = {
  // Pending: 0,
  // Reedemed: 1,
  // Expired: 2,
  // Declined: 3
  Pending: 0,
  Completed: 1,
  Reedemed: 2,
  Cancelled: 3,
  Declined: 4
};

export const bookingStatusTabsOther = {
  // Pending: 0,
  // Accepted: 1,
  // Expired: 2,
  // Declined: 3
  Pending: 0,
  Completed: 1,
  Reedemed: 2,
  Cancelled: 3,
  Declined: 4
};

export const statusConst = [
  {
    key: 'Accepted',
    value: 1
  },
  {
    key: 'Rejected',
    value: 2
  }
];

export const StatusConst = {
  PENDING: 0,
  ACCEPTED: 1,
  REJECTED: 2
};

export const PackageBookingConst = {
  Normal: 0,
  Daily: 1,
  Slots: 2,
  Hourly: 3,
  Monthly: 6
};

export const RedeemBooking = {
  Pending: 0,
  Redeemed: 1
};

export const RedeemBookingStatus : Array<keyValuePair> = [
  {
    key: 'Yes',
    value: RedeemBooking.Redeemed
  },
  {
    key: 'No',
    value: RedeemBooking.Pending
  }
];

export const PACKAGE_BOOKING_TYPE_CONST: Array<keyValuePair> = [
  {
    key: 'Normal',
    value: PackageBookingConst.Normal
  },
  {
    key: 'Daily',
    value: PackageBookingConst.Daily
  },
  {
    key: 'Slots',
    value: PackageBookingConst.Slots
  },
  {
    key: 'Hourly',
    value: PackageBookingConst.Hourly
  },
  {
    key: 'Monthly',
    value: PackageBookingConst.Monthly
  }
];

export const PackageTimeConst = {
  FifteenMinutes: 15,
  ThirtyMinutes: 30,
  FortyFiveMinutes: 45,
  SixtyMinutes: 60,
  OneTwentyMinutes: 120,
  TwoFortyMinutes: 240,
  FourEightyMinutes: 480
};

export const PACKAGE_TIME_OPTIONS: Array<keyValuePair> = [
  {
    key: '15 min',
    value: PackageTimeConst.FifteenMinutes
  },
  {
    key: '30 min',
    value: PackageTimeConst.ThirtyMinutes
  },
  {
    key: '45 min',
    value: PackageTimeConst.FortyFiveMinutes
  },
  {
    key: '1 hour',
    value: PackageTimeConst.SixtyMinutes
  },
  {
    key: '2 hours',
    value: PackageTimeConst.OneTwentyMinutes
  },
  {
    key: '4 hours',
    value: PackageTimeConst.TwoFortyMinutes
  },
  {
    key: '8 hours',
    value: PackageTimeConst.FourEightyMinutes
  }
];

